module.exports = __webpack_public_path__ + "media/images/flags/4x3/vut-f228f473e20a04fc0d9c291d235807d8.svg";